const LOAD_CANDIDATE_NOTIFICATION           = 'LOAD_CANDIDATE_NOTIFICATION'
const LOAD_CANDIDATE_NOTIFICATION_SUCCESS   = 'LOAD_CANDIDATE_NOTIFICATION_SUCCESS'
const LOAD_CANDIDATE_NOTIFICATION_FAILED    = 'LOAD_CANDIDATE_NOTIFICATION_FAILED'
const UNMOUNT_CANDIDATE_NOTIFICATION        = 'UNMOUNT_CANDIDATE_NOTIFICATION'
const initialState = {
  loading: true,
  data: null,
  message: null,
}
const candidateNotificationReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_CANDIDATE_NOTIFICATION:
      return {
        ...state,
        loading: true,
        data: null,
      }
    case LOAD_CANDIDATE_NOTIFICATION_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_CANDIDATE_NOTIFICATION_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_CANDIDATE_NOTIFICATION:
      return { 
        ...state, 
        loading: true,
        data: null,
      }
    default:
      return state
  }
}
export default candidateNotificationReducer;